


























import Vue from 'vue';
import { mapState, mapMutations } from 'vuex';
import CloseIcon from '../../assets/img/close.svg';
import TertiaryButton from '@/components/common/buttons/TertiaryButton.vue';
import { ErrorMessage } from '@/utils/ErrorMessage';
export default Vue.extend({
    components: {
        CloseIcon,
        TertiaryButton,
    },
    computed: {
        ...mapState(['errorMessages']),
    },
    methods: {
        ...mapMutations(['removeErrorMessage', 'removeAllErrorMessages']),
        handleClick(errorMessage: ErrorMessage) {
            if (!window.getSelection()?.toString()) {
                this.removeErrorMessage({ errorMessage });
            }
        },
    },
});
